import React, { useState } from "react";
import {
  Button,
  Box,
  Dialog,
  SvgIcon,
  AppBar,
  Toolbar,
  Typography,
  Grid,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Divider,
  Slide,
  ListItemIcon,
  ListItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import { PARENT_MENU_LIST } from "./HeaderMenuLists";
import { ReactComponent as SogLogo } from "../../../assets/svgs/sog-logo.svg";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const HeaderMobile = ({ currentPage }) => {
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <AppBar
      component={"nav"}
      position="fixed"
      className="sog-mob-header"
      sx={{
        backgroundColor: "#FFFFFF",
        boxShadow: "none",
        top: 0,
        zIndex: 99,
      }}
    >
      <Toolbar
        sx={{
          height: "72px",
          paddingTop: "7px",
          paddingBottom: "5px",
          width: "93%", // use percentage width
          margin: "0 auto", // center it horizontally
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={5}>
            <Grid size={{ xs: 7, md: 7 }}>
              <div className="mobile-header-logo">
                <ListItem component={Link} to={"/home"}>
                <SvgIcon component={SogLogo} inheritViewBox />
                </ListItem>
              </div>
            </Grid>
            <Grid size={{ xs: 5, md: 5 }}>
              <div className="mobile-header-menu">
                <Button variant="outlined" onClick={handleClickOpen}>
                  <MenuIcon />
                </Button>
              </div>
            </Grid>
          </Grid>
        </Box>
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          slots={{
            transition: Transition,
          }}
          className="mobile-menu-popup"
        >
          <AppBar sx={{ position: "relative" }} className="">
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                {" "}
              </Typography>
              <Button autoFocus color="inherit" onClick={handleClose}>
                Close
              </Button>
            </Toolbar>
          </AppBar>
          <List>
            {PARENT_MENU_LIST.map((item, index) => (
              <React.Fragment key={index}>
                <ListItemButton
                  component={Link}
                  to={item.hrefLink}
                  onClick={handleClose}
                  selected={currentPage === item.label}
                  className="mobile-menu-list"
                >
                  <ListItemIcon className="mobile-menu-icon">
                    <SvgIcon component={item.iconPath} inheritViewBox />
                  </ListItemIcon>
                  <ListItemText primary={item.label} />
                </ListItemButton>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </Dialog>
      </Toolbar>
    </AppBar>
  );
};
